import styled from "styled-components";
// import { Button } from "../../sdk/Buttons";

const primary = "#A5836D";

export const Spacer = styled.div`
    height: ${(props) => props.height ?? "10"}px;
`;

export const Layout = styled.div`
    position: relative;
    margin-top: 10%;
    margin-bottom: 10%;
    left: 0;
    /* transform: translateY(-50%); */
    width: 100%;
    .logo-svg {
        fill: #112c55 !important;
        color: #112c55 !important;
        margin-bottom: 20px;
    }
    .wrap {
        margin: auto;
        width: 98%;
        text-align: center;
        &.wrap--800 {
            max-width: 800px;
        }
    }

    .logo {
        width: 200px;
        margin-bottom: 20px;
    }

    .heading {
        text-align: center;
        margin-bottom: 30px;
        h2 {
            font-size: 35px;
        }
        h3 {
            font-size: 18px;
            margin-top: 20px;
            font-weight: normal;
        }
        @media (max-width: 580px) {
            h2 {
                font-size: 25px;
            }
            h3 {
                font-size: 18px;
                margin-top: 10px;
            }
        }
    }

    .button {
        &.primary {
            background-color: ${primary};
            border-color: ${primary};
            color: white;
        }
        &.noritex {
            background-color: #112c55;
            border-color: #112c55;
            color: white;
        }
        &.big {
            font-size: 18px;
            height: 60px;
            line-height: 56px;
        }
        &.rounded {
            border-radius: 30px;
        }
        &.outline {
            border: solid 1px white;
            &.white {
                color: white;
            }
        }
    }

    .buttons {
        .button {
            margin: 10px !important;
        }
    }

    .social {
        padding-top: 30px;
        a {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            margin: 5px;
            width: 40px;
            height: 40px;
            border-radius: 40px;
            color: white;
            background-color: gray;
            &:hover {
                background-color: #555555;
            }
            .icon {
            }
        }
    }
`;
